import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";
import { isIrisDialogEnabled } from "owa-iris-store";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "IrisCampaignDialog" */ "./lazyIndex"), { name: "IrisCampaignDialog" });

export const LazyIrisCampaignDialogHost: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.IrisCampaignDialogHost, undefined, undefined, { onlyImportIf: isIrisDialogEnabled });
